import React from 'react';
import SVG from 'react-inlinesvg';
import { Link, Text } from '@perch-labs/shrike';
import { Container } from 'styles';
import { Statuses } from '../vnm-status.component';
import { StyledContainer } from './styled-status.style';
import { getStyleMap } from './styled-status.utils';

interface Props {
  status: Statuses;
  projectStartDate?: Date;
  projectName?: string;
  percentSavings?: number;
  isSMB?: boolean;
}

const BLOG_LINK = 'https://www.arcadia.com/blog/how-to-build-a-solar-farm';

export const StyledStatus = ({
  status,
  projectStartDate,
  projectName,
  percentSavings,
  isSMB = false,
}: Props) => {
  const styleMap = getStyleMap({
    percentSavings,
    projectName,
    projectStartDate,
  });
  const { color, svg, text, title } = styleMap[status];

  return (
    <StyledContainer color={color}>
      <div>
        <SVG
          src={svg}
          height="40px"
          width="40px"
          aria-hidden={true}
          data-testid={`${status}-svg`}
        />
      </div>
      <Container margin={{ left: '24px' }}>
        <Text>{title}</Text>
        <Text color="secondary" textStyle="paragraph400">
          {text}
        </Text>
        {isSMB && (
          <Link
            style={{ fontSize: '0.875rem' }}
            openInNewTab={true}
            type="inline"
            href={BLOG_LINK}
            onClick={e => e.stopPropagation()}
          >
            Why the wait?
          </Link>
        )}
      </Container>
    </StyledContainer>
  );
};
